import { useDispatch, useSelector } from 'react-redux';

import { formatDate } from 'utils/date';

import {
  getAletsData,
  setAletsData,
  setShowNewAlertNotification,
} from 'store/alerts';

import { loadAlerts, saveAlerts } from 'core/storage/alertsStorage';
import type { AlertValues } from 'views/Alerts/models/alert';

const useAlerts = () => {
  const dispatch = useDispatch();
  const aletsData = useSelector(getAletsData);

  const loadAlertsData = () => {
    const data = loadAlerts();
    if (!data) {
      return;
    }

    const currentDate = formatDate(new Date(), 'yyyy-MM-dd');

    const newAlerts =
      data.filter((item: AlertValues) => item.data === currentDate) || [];

    dispatch(setAletsData(newAlerts));
  };

  const handleAddAlert = ({ description = '', eventType = '' }) => {
    const newAlert = {
      id: new Date().getDate(),
      description,
      eventType,
      date: formatDate(new Date(), 'yyyy-MM-dd'),
      isSelected: false,
      viewed: false,
    };

    const newAlerts = [newAlert, ...aletsData];

    dispatch(setAletsData(newAlerts));
    dispatch(setShowNewAlertNotification(true));

    saveAlerts(newAlerts);
  };

  const handleDeleteAlert = () => {
    const newAlerts = aletsData.filter((item) => !item.isSelected) || [];
    dispatch(setAletsData(newAlerts));
    saveAlerts(newAlerts);
  };

  return { handleAddAlert, handleDeleteAlert, loadAlertsData };
};

export default useAlerts;
